import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["icon", "description", "elemAfter", "shouldAllowMultiline", "onClick", "children", "lozenges", "product", "createAnalyticsEvent", "tag", "href"];
var _lozengeData;
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { RenderTracker, SWITCHER_ITEM_LOZENGES_SUBJECT } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Lozenge from '@atlaskit/lozenge';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';
import ErrorBoundary from '../components/error-boundary';
export var LozengeType = /*#__PURE__*/function (LozengeType) {
  LozengeType["New"] = "new";
  LozengeType["Try"] = "try";
  return LozengeType;
}({});
var lozengeData = (_lozengeData = {}, _defineProperty(_lozengeData, LozengeType.New, {
  label: messages.newLozenge,
  componentProps: {
    appearance: 'new'
  }
}), _defineProperty(_lozengeData, LozengeType.Try, {
  label: messages.tryLozenge,
  componentProps: {
    appearance: 'new'
  }
}), _lozengeData);
var fadeInStyles = css({
  width: '100%'
});
var childrenStyles = css({
  lineHeight: '14px',
  minHeight: '16px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var itemDescriptionStyles = css({
  color: "var(--ds-text-subtlest, #626F86)",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  lineHeight: "var(--ds-space-150, 12px)",
  fontWeight: "var(--ds-font-weight-regular, 400)"
});
var SwitcherItem = function SwitcherItem(_ref) {
  var icon = _ref.icon,
    description = _ref.description,
    elemAfter = _ref.elemAfter,
    shouldAllowMultiline = _ref.shouldAllowMultiline,
    _onClick = _ref.onClick,
    children = _ref.children,
    lozenges = _ref.lozenges,
    product = _ref.product,
    createAnalyticsEvent = _ref.createAnalyticsEvent,
    tag = _ref.tag,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var itemDescription = React.useMemo(function () {
    if ( /*#__PURE__*/React.isValidElement(description) || typeof description === 'string') {
      return jsx("div", {
        css: itemDescriptionStyles
      }, description);
    }
    return undefined;
  }, [description]);
  var renderLozenges = React.useMemo(function () {
    if (!(lozenges !== null && lozenges !== void 0 && lozenges.length)) {
      return null;
    }
    return jsx(ErrorBoundary, {
      product: product,
      triggerSubject: "switcherItemLozengeErrorBoundary",
      hideFallbackUI: true
    }, jsx(React.Fragment, null, lozenges.map(function (lozenge, index) {
      var _lozengeData$lozenge = lozengeData[lozenge],
        componentProps = _lozengeData$lozenge.componentProps,
        label = _lozengeData$lozenge.label;
      return jsx("span", {
        key: index
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
          marginLeft: "var(--ds-space-100, 8px)"
        }
      }, jsx(Lozenge, _extends({}, componentProps, {
        "data-testid": "switcher-item-lozenge"
      }), jsx(FormattedMessage, label)));
    }), jsx(RenderTracker, {
      subject: SWITCHER_ITEM_LOZENGES_SUBJECT,
      data: {
        product: product,
        lozenges: lozenges,
        children: children,
        description: description
      }
    })));
  }, [lozenges, product, children, description]);
  return jsx(FadeIn, {
    css: fadeInStyles,
    tag: tag
  }, jsx(LinkItem, _extends({
    testId: "switcher-base-item",
    description: itemDescription,
    iconBefore: icon,
    iconAfter: elemAfter,
    target: "_blank",
    href: href !== null && href !== void 0 ? href : '#',
    onClick: function onClick(event) {
      // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
      if (!href) {
        event.preventDefault();
      }
      if (_onClick) {
        _onClick(event);
      }
    }
  }, rest), jsx("span", {
    css: childrenStyles
  }, children, renderLozenges)));
};
export default SwitcherItem;